var _path, _path2, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAudit(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 24,
    viewBox: "0 0 36 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_85_442)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_85_442",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 36,
    height: 24
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36 0H0V24H36V0Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_85_442)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_85_442",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 36,
    height: 24
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M36 0H0V24H36V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_85_442)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.54155 15.8527C4.62551 15.9557 0.636366 19.2849 0.289062 23.4854H4.94294L4.94518 23.4595C5.16925 20.7455 6.55847 18.2265 8.8569 16.3673C9.07872 16.1883 9.30727 16.0165 9.54155 15.8527ZM11.3978 7.45832C11.3978 6.85881 11.4613 6.27649 11.5798 5.72055C11.0294 5.42205 10.4192 5.25449 9.77632 5.25449C7.34619 5.25449 5.37639 7.62612 5.37639 10.5522C5.37639 13.3892 7.22793 15.7045 9.554 15.8435C10.6002 15.1145 11.7663 14.5439 13.0066 14.1468C13.269 13.8067 13.4926 13.4243 13.6741 13.0095C12.2899 11.7199 11.3978 9.71119 11.3978 7.45832ZM23.4415 7.39533C23.4415 3.68353 20.9426 0.674805 17.8604 0.674805C14.778 0.674805 12.2794 3.68353 12.2794 7.39533C12.2794 10.7215 14.2868 13.4843 16.9228 14.0203C10.9838 14.4151 6.251 18.529 5.82552 23.6741H29.8953C29.4696 18.529 24.7371 14.4151 18.7975 14.0205C21.4336 13.4843 23.4415 10.7223 23.4415 7.39533ZM30.344 10.7419C30.344 7.81583 28.3742 5.44395 25.9438 5.44395C25.3007 5.44395 24.6912 5.61225 24.1405 5.91001C24.2598 6.46595 24.322 7.04852 24.322 7.64778C24.322 9.9009 23.4302 11.9093 22.0455 13.198C22.2263 13.6127 22.4506 13.9951 22.7122 14.336C23.9531 14.7333 25.119 15.3039 26.1649 16.0322C28.4929 15.894 30.344 13.5784 30.344 10.7419ZM35.4318 23.6748C35.0842 19.4743 31.0953 16.1454 26.1793 16.0424C26.4133 16.2059 26.6416 16.3775 26.8637 16.5567C29.1616 18.4162 30.5514 20.935 30.7757 23.6482L30.7779 23.6741L35.4318 23.6748Z",
    fill: "#1e2a4a"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_85_442"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAudit);
export default __webpack_public_path__ + "static/media/audit.4fb82082e2044eac29cc7f8adfa85e65.svg";
export { ForwardRef as ReactComponent };